require('./dots.scss');

var DOT_CLASS = 'dots-enabled';

function enableDots($owlCarousel) {
    $owlCarousel.addClass(DOT_CLASS);
}

function disableDots($owlCarousel) {
    $owlCarousel.removeClass(DOT_CLASS);
}

module.exports = {
    enableDots: enableDots,
    disableDots: disableDots
};


//////////////////
// WEBPACK FOOTER
// ./src/interlock/ui/owl-carousel/customization/dots.js
// module id = 41
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 12 13 14 15 17